import { IconCheck, IconTrash, IconX, IconArrowRight, IconClock } from '@tabler/icons-react';
import { useState } from 'react';

export default function HistoryLog({ history, onClear }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const getOperationIcon = (type) => {
    switch (type) {
      case 'transfer': return <IconArrowRight className="w-4 h-4 text-amber-500" />;
      case 'pindah': return <IconArrowRight className="w-4 h-4 text-blue-500" />;
      case 'hapus': return <IconTrash className="w-4 h-4 text-red-500" />;
      default: return <IconCheck className="w-4 h-4 text-green-500" />;
    }
  };

  const getOperationLabel = (type) => {
    switch (type) {
      case 'transfer': return 'Transfer Cabang';
      case 'pindah': return 'Pindah Etalase/Brankas';
      case 'hapus': return 'Hapus Barang';
      default: return 'Operasi';
    }
  };

  const getOperationColor = (type) => {
    switch (type) {
      case 'transfer': return 'amber';
      case 'pindah': return 'blue';
      case 'hapus': return 'red';
      default: return 'green';
    }
  };

  if (history.length === 0) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-700/60 shadow-sm overflow-hidden">
      {/* Header */}
      <div
        className="px-4 py-3 bg-slate-50 dark:bg-slate-800/50 border-b border-slate-200 dark:border-slate-700/60 flex items-center justify-between cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          <IconClock className="w-5 h-5 text-slate-500 dark:text-slate-400" />
          <span className="font-semibold text-slate-700 dark:text-slate-200">
            Riwayat Sesi Ini ({history.length})
          </span>
        </div>
        <div className="flex items-center gap-2">
          {history.length > 0 && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onClear();
              }}
              className="p-1.5 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 text-slate-500 dark:text-slate-400 hover:text-red-600 dark:hover:text-red-400 transition-colors"
              title="Hapus Riwayat"
            >
              <IconX className="w-4 h-4" />
            </button>
          )}
          <IconX
            className={`w-5 h-5 text-slate-500 dark:text-slate-400 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
          />
        </div>
      </div>

      {/* Content */}
      {isExpanded && (
        <div className="p-4 max-h-64 overflow-y-auto">
          <div className="space-y-2">
            {history.map((log, index) => (
              <div
                key={index}
                className="flex items-start gap-3 p-3 bg-slate-50 dark:bg-slate-800/30 rounded-lg border border-slate-100 dark:border-slate-700/40"
              >
                <div className="flex-shrink-0 mt-0.5">
                  {getOperationIcon(log.type)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-medium text-sm text-slate-700 dark:text-slate-200">
                      {getOperationLabel(log.type)}
                    </span>
                    <span className="text-xs text-slate-400 dark:text-slate-500 whitespace-nowrap">
                      {log.timestamp}
                    </span>
                  </div>
                  <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                    {log.itemCount} barang diproses
                  </p>
                  {log.details && (
                    <p className="text-xs text-slate-400 dark:text-slate-500 mt-0.5 truncate">
                      {log.details}
                    </p>
                  )}
                </div>
                <div className={`flex-shrink-0 w-2 h-2 rounded-full bg-${getOperationColor(log.type)}-500`} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
